// Shared role labels + helpers for the 5-tier RBAC (Track B school hierarchy +
// Track A instructor hierarchy). Keep labels student-facing: "Student", never "Learner".
export const ROLE_LABELS = {
  super_admin: "Super Admin",
  school_board_admin: "Board Admin",
  school_admin: "School Admin",
  teacher: "Teacher",
  level2_instructor: "Level 2 Instructor",
  level1_instructor: "Level 1 Instructor",
  public_student: "Student",
  anonymous_token_student: "Student",
  team_dev: "Team — Developer",
  team_content: "Team — Content",
};

// Roles a Super Admin can assign, ordered high → low for menus.
export const ASSIGNABLE_ROLES = [
  "school_board_admin",
  "school_admin",
  "teacher",
  "level2_instructor",
  "level1_instructor",
  "public_student",
];

export const roleLabel = (r) => ROLE_LABELS[r] || (r || "").replace(/_/g, " ");
